import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StoreModel } from '../../interfaces/store-interfaces';

@Injectable({
  providedIn: 'root',
})
export class StoreGatewayService {
  private urlPrefix: string = '/store';

  constructor(private httpClient: HttpClient) {}

  public list(): Observable<StoreModel[]> {
    return this.httpClient.get<StoreModel[]>(`${environment.api.url}${this.urlPrefix}`);
  }

  public edit(updatedStore: StoreModel): Observable<StoreModel> {
    return this.httpClient.put<StoreModel>(`${environment.api.url}${this.urlPrefix}/${updatedStore.id}`, updatedStore);
  }

  public delete(storeId: number): Observable<StoreModel> {
    return this.httpClient.delete<StoreModel>(`${environment.api.url}${this.urlPrefix}/${storeId}`);
  }

  public create(newStore: Partial<StoreModel>): Observable<StoreModel> {
    return this.httpClient.post<StoreModel>(`${environment.api.url}${this.urlPrefix}`, newStore);
  }
}
